// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {FETCH_LOGS, CLEAR_LOGS} from '../actions/auditViewer'

const initialState = {
  logs: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_LOGS:
      return {...state, logs: action.payload.logs}
    case CLEAR_LOGS:
      return {...state, logs: ''}
    default:
      return state
  }
}
